// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/V2/background_landing.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}


::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}


/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*/


/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/


*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}


::before,
::after {
  --tw-content: '';
}


/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/


html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}


/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/


body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}


/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/


hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}


/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/


abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}


/*
Remove the default font size and weight for headings.
*/


h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}


/*
Reset links to optimize for opt-in styling instead of opt-out.
*/


a {
  color: inherit;
  text-decoration: inherit;
}


/*
Add the correct font weight in Edge and Safari.
*/


b,
strong {
  font-weight: bolder;
}


/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/


code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}


/*
Add the correct font size in all browsers.
*/


small {
  font-size: 80%;
}


/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/


sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}


sub {
  bottom: -0.25em;
}


sup {
  top: -0.5em;
}


/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/


table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}


/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/


button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}


/*
Remove the inheritance of text transform in Edge and Firefox.
*/


button,
select {
  text-transform: none;
}


/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/


button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}


/*
Use the modern Firefox focus style for all focusable elements.
*/


:-moz-focusring {
  outline: auto;
}


/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/


:-moz-ui-invalid {
  box-shadow: none;
}


/*
Add the correct vertical alignment in Chrome and Firefox.
*/


progress {
  vertical-align: baseline;
}


/*
Correct the cursor style of increment and decrement buttons in Safari.
*/


::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}


/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/


[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}


/*
Remove the inner padding in Chrome and Safari on macOS.
*/


::-webkit-search-decoration {
  -webkit-appearance: none;
}


/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/


::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}


/*
Add the correct display in Chrome and Safari.
*/


summary {
  display: list-item;
}


/*
Removes the default spacing and border for appropriate elements.
*/


blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}


fieldset {
  margin: 0;
  padding: 0;
}


legend {
  padding: 0;
}


ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}


/*
Reset default styling for dialogs.
*/


dialog {
  padding: 0;
}


/*
Prevent resizing textareas horizontally by default.
*/


textarea {
  resize: vertical;
}


/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/


input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}


/*
Set the default cursor for buttons.
*/


button,
[role="button"] {
  cursor: pointer;
}


/*
Make sure disabled buttons don't get the pointer cursor.
*/


:disabled {
  cursor: default;
}


/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/


img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}


/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/


img,
video {
  max-width: 100%;
  height: auto;
}


/* Make elements with the HTML hidden attribute stay hidden by default */


[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 350px){


  .container{
    max-width: 350px;
  }
}
@media (min-width: 400px){


  .container{
    max-width: 400px;
  }
}
@media (min-width: 640px){


  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){


  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){


  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){


  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1400px){


  .container{
    max-width: 1400px;
  }
}
@media (min-width: 1536px){


  .container{
    max-width: 1536px;
  }
}
@media (min-width: 2050px){


  .container{
    max-width: 2050px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.not-sr-only{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.-bottom-\\[33\\%\\]{
  bottom: -33%;
}
.-left-5{
  left: -1.25rem;
}
.-left-64{
  left: -16rem;
}
.-top-5{
  top: -1.25rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-\\[120px\\]{
  bottom: 120px;
}
.bottom-\\[15\\.09\\%\\]{
  bottom: 15.09%;
}
.bottom-\\[17\\.36\\%\\]{
  bottom: 17.36%;
}
.bottom-\\[18\\.09\\%\\]{
  bottom: 18.09%;
}
.bottom-\\[18\\.77\\%\\]{
  bottom: 18.77%;
}
.bottom-\\[19\\.50\\%\\]{
  bottom: 19.50%;
}
.bottom-\\[35\\%\\]{
  bottom: 35%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-\\[45\\%\\]{
  left: 45%;
}
.left-\\[47\\%\\]{
  left: 47%;
}
.left-\\[49\\.48\\%\\]{
  left: 49.48%;
}
.left-\\[49\\.88\\%\\]{
  left: 49.88%;
}
.left-\\[52\\.88\\%\\]{
  left: 52.88%;
}
.left-\\[62\\.4\\%\\]{
  left: 62.4%;
}
.left-\\[66\\%\\]{
  left: 66%;
}
.right-0{
  right: 0px;
}
.right-3{
  right: 0.75rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-14{
  top: 3.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-50{
  z-index: 50;
}
.m-10{
  margin: 2.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-20{
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.-mt-\\[122px\\]{
  margin-top: -122px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-\\[200px\\]{
  margin-left: 200px;
}
.ml-\\[210px\\]{
  margin-left: 210px;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-7{
  margin-right: 1.75rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-36{
  margin-top: 9rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-40{
  margin-top: 10rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-\\[26px\\]{
  margin-top: 26px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.grid{
  display: grid;
}
.list-item{
  display: list-item;
}
.hidden{
  display: none;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\/4{
  height: 75%;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[170\\%\\]{
  height: 170%;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-\\[calc\\(100\\%\\)\\]{
  height: calc(100%);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.max-h-0{
  max-height: 0px;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-\\[220px\\]{
  max-height: 220px;
}
.max-h-\\[608px\\]{
  max-height: 608px;
}
.max-h-full{
  max-height: 100%;
}
.min-h-96{
  min-height: 24rem;
}
.min-h-full{
  min-height: 100%;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-32{
  width: 8rem;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[1200px\\]{
  width: 1200px;
}
.w-\\[125px\\]{
  width: 125px;
}
.w-\\[1620px\\]{
  width: 1620px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[270px\\]{
  width: 270px;
}
.w-\\[275px\\]{
  width: 275px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-56{
  min-width: 14rem;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.grow{
  flex-grow: 1;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-5{
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-105{
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{


  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-copy{
  cursor: copy;
}
.cursor-pointer{
  cursor: pointer;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize{
  resize: both;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-center{
  align-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-20{
  column-gap: 5rem;
}
.gap-x-7{
  column-gap: 1.75rem;
}
.gap-y-10{
  row-gap: 2.5rem;
}
.gap-y-2\\.5{
  row-gap: 0.625rem;
}
.gap-y-5{
  row-gap: 1.25rem;
}
.space-x-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--tw-space-x-reverse));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1.75rem * var(--tw-space-x-reverse));
  margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-14 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-20 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-\\[\\#505050\\]\\/30{
  border-color: rgb(80 80 80 / 0.3);
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-zinc-500\\/30{
  border-color: rgb(113 113 122 / 0.3);
}
.bg-\\[\\#003C6A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 60 106 / var(--tw-bg-opacity));
}
.bg-\\[\\#012542\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(1 37 66 / var(--tw-bg-opacity));
}
.bg-\\[\\#1B71B4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 113 180 / var(--tw-bg-opacity));
}
.bg-\\[\\#1B75BB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 117 187 / var(--tw-bg-opacity));
}
.bg-\\[\\#505050\\]\\/20{
  background-color: rgb(80 80 80 / 0.2);
}
.bg-\\[\\#5F80A9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(95 128 169 / var(--tw-bg-opacity));
}
.bg-\\[\\#D9D9D9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}
.bg-\\[\\#EC2027\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 32 39 / var(--tw-bg-opacity));
}
.bg-\\[\\#F1F1F1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity));
}
.bg-\\[\\#F6686D\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 104 109 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFBABC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 186 188 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-55{
  --tw-bg-opacity: 0.55;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#1B75BB\\]{
  --tw-gradient-from: #1B75BB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(27 117 187 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EC2027\\]{
  --tw-gradient-from: #EC2027 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 32 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#0a1015\\]{
  --tw-gradient-to: #0a1015 var(--tw-gradient-to-position);
}
.to-\\[\\#1B75BB\\]{
  --tw-gradient-to: #1B75BB var(--tw-gradient-to-position);
}
.to-\\[\\#1E5885\\]{
  --tw-gradient-to: #1E5885 var(--tw-gradient-to-position);
}
.to-\\[\\#861216\\]{
  --tw-gradient-to: #861216 var(--tw-gradient-to-position);
}
.to-blue-500{
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-\\[5px\\]{
  padding: 5px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[40px\\]{
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[65px\\]{
  padding-top: 65px;
  padding-bottom: 65px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-\\[50\\.5px\\]{
  padding-left: 50.5px;
}
.pl-\\[51px\\]{
  padding-left: 51px;
}
.pl-\\[55px\\]{
  padding-left: 55px;
}
.pl-\\[56\\.5px\\]{
  padding-left: 56.5px;
}
.pr-0{
  padding-right: 0px;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-36{
  padding-top: 9rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[25px\\]{
  font-size: 25px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-cust-14{
  font-size: 14px;
}
.text-cust-16{
  font-size: 16px;
}
.text-cust-18{
  font-size: 18px;
}
.text-cust-21{
  font-size: 21px;
}
.text-cust-22{
  font-size: 22px;
}
.text-cust-24{
  font-size: 24px;
}
.text-cust-32{
  font-size: 32px;
}
.text-cust-42{
  font-size: 42px;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-none{
  line-height: 1;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.text-\\[\\#1B75BB\\]{
  --tw-text-opacity: 1;
  color: rgb(27 117 187 / var(--tw-text-opacity));
}
.text-\\[\\#505050\\]{
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}
.text-\\[\\#D6D6D6\\]{
  --tw-text-opacity: 1;
  color: rgb(214 214 214 / var(--tw-text-opacity));
}
.text-\\[\\#EC2027\\]{
  --tw-text-opacity: 1;
  color: rgb(236 32 39 / var(--tw-text-opacity));
}
.text-\\[\\#F1F1F1\\]{
  --tw-text-opacity: 1;
  color: rgb(241 241 241 / var(--tw-text-opacity));
}
.text-\\[\\#FFFFFF\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.no-underline{
  text-decoration-line: none;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-50{
  opacity: 0.5;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#DFE9FC\\]\\/50{
  --tw-ring-color: rgb(223 233 252 / 0.5);
}
.ring-\\[\\#FFBABC\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 186 188 / var(--tw-ring-opacity));
}
.ring-zinc-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(228 228 231 / var(--tw-ring-opacity));
}
.ring-offset-4{
  --tw-ring-offset-width: 4px;
}
.ring-offset-\\[\\#F6686D\\]{
  --tw-ring-offset-color: #F6686D;
}
.drop-shadow-lg{
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-300{
  transition-delay: 300ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}


*{
  font-family: "Poppins", sans-serif;
  box-sizing:border-box;

}

.homelandingpage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
}

.list-container {
  position: absolute;
  width: 90%;
  height: 15%;
  bottom: 20px;
  right: 35px;
  
}

@media (width: 344px) {
  .titlesamsungfold {
    font-size: 13px !important;
  }
  .psamsungfold {
    font-size: 12px !important;
  }
}

.list-item {
  border-radius: 25px;
  overflow: hidden;
  background-color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: start;
  transform: translateY(100%);
  opacity: 0;
  animation: slideUpMotion 16s infinite;
}

@keyframes slideUpMotion {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  5%, 25% {
    transform: translateY(0);
    opacity: 1;
  }
  30% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(-100%);
    opacity: 0;
  }
}

/* Atur delay untuk setiap item */
.list-item:nth-child(1) {
  animation-delay: 0s;
}

.list-item:nth-child(2) {
  animation-delay: 4s;
}

.list-item:nth-child(3) {
  animation-delay: 8s;
}

.list-item:nth-child(4) {
  animation-delay: 12s;
}


/* Slider Container */
.slider {
  position: relative;
  width: 100%;
  
  overflow: hidden;
  
}


.bubble::before,
.bubble::after {
  content: "";
  position: absolute;
  width: 100px;
  height: 100%;
  z-index: 2;
  background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)}

/* Slide Track */
.slide-track-image1 {
  display: flex;
  width: calc(210px * 22); /* 22 images */
  animation: scroll-custom-image1 30s linear infinite;
}

/* bubble */
.slide-track-image2 {
  display: flex;
  width: calc(280px * 10); /* 10 images */
  animation: scroll-custom-image2 15s linear infinite;

}

/* Individual Slide */
.slide-image1 {
  display: flex;
  width: 210px;
  height: 75px;
  align-items: center;
  justify-content: center;
}

.slide-image2 {
  width: 280px;
}



@keyframes scroll-custom-image1 {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-210px * 11));
  }
}

@keyframes scroll-custom-image2 {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-280px * 5));
  }
}


/* width */
::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
	background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #EC2027;
	border-radius: 20px;
	width: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #ff3a41;
}
.placeholder\\:font-light::placeholder{
  font-weight: 300;
}
.placeholder\\:text-zinc-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.hover\\:border-\\[\\#EC2027\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(236 32 39 / var(--tw-border-opacity));
}
.hover\\:border-red-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.hover\\:bg-\\[\\#EC2027\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 32 39 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-gradient-to-l:hover{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity));
}
.group:hover .group-hover\\:visible{
  visibility: visible;
}
.group:hover .group-hover\\:-translate-x-2{
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
@media (min-width: 350px){


  .w350\\:h-\\[22px\\]{
    height: 22px;
  }


  .w350\\:h-\\[24px\\]{
    height: 24px;
  }


  .w350\\:w-12{
    width: 3rem;
  }


  .w350\\:w-14{
    width: 3.5rem;
  }


  .w350\\:w-32{
    width: 8rem;
  }


  .w350\\:w-\\[60px\\]{
    width: 60px;
  }
}
@media (min-width: 400px){


  .w400\\:h-6{
    height: 1.5rem;
  }


  .w400\\:h-7{
    height: 1.75rem;
  }


  .w400\\:w-14{
    width: 3.5rem;
  }


  .w400\\:w-16{
    width: 4rem;
  }


  .w400\\:w-28{
    width: 7rem;
  }
}
@media (min-width: 640px){


  .sm\\:-mt-32{
    margin-top: -8rem;
  }


  .sm\\:w-3\\/4{
    width: 75%;
  }


  .sm\\:w-\\[calc\\(100\\%-1rem\\)\\]{
    width: calc(100% - 1rem);
  }


  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }


  .sm\\:justify-center{
    justify-content: center;
  }


  .sm\\:gap-y-0{
    row-gap: 0px;
  }


  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }


  .sm\\:pb-20{
    padding-bottom: 5rem;
  }


  .sm\\:pl-24{
    padding-left: 6rem;
  }
}
@media (min-width: 768px){


  .md\\:-left-80{
    left: -20rem;
  }


  .md\\:left-0{
    left: 0px;
  }


  .md\\:ml-0{
    margin-left: 0px;
  }


  .md\\:ml-10{
    margin-left: 2.5rem;
  }


  .md\\:ml-14{
    margin-left: 3.5rem;
  }


  .md\\:mt-0{
    margin-top: 0px;
  }


  .md\\:flex{
    display: flex;
  }


  .md\\:hidden{
    display: none;
  }


  .md\\:h-14{
    height: 3.5rem;
  }


  .md\\:h-6{
    height: 1.5rem;
  }


  .md\\:h-7{
    height: 1.75rem;
  }


  .md\\:w-1\\/3{
    width: 33.333333%;
  }


  .md\\:w-16{
    width: 4rem;
  }


  .md\\:w-20{
    width: 5rem;
  }


  .md\\:w-28{
    width: 7rem;
  }


  .md\\:w-3\\/5{
    width: 60%;
  }


  .md\\:w-32{
    width: 8rem;
  }


  .md\\:w-36{
    width: 9rem;
  }


  .md\\:w-40{
    width: 10rem;
  }


  .md\\:w-52{
    width: 13rem;
  }


  .md\\:w-\\[15px\\]{
    width: 15px;
  }


  .md\\:w-\\[2000px\\]{
    width: 2000px;
  }


  .md\\:w-\\[2400px\\]{
    width: 2400px;
  }


  .md\\:w-\\[320px\\]{
    width: 320px;
  }


  .md\\:w-\\[360px\\]{
    width: 360px;
  }


  .md\\:w-\\[400px\\]{
    width: 400px;
  }


  .md\\:w-\\[500px\\]{
    width: 500px;
  }


  .md\\:w-full{
    width: 100%;
  }


  .md\\:min-w-\\[280px\\]{
    min-width: 280px;
  }


  .md\\:min-w-\\[492px\\]{
    min-width: 492px;
  }


  .md\\:max-w-\\[492px\\]{
    max-width: 492px;
  }


  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }


  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }


  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }


  .md\\:flex-row{
    flex-direction: row;
  }


  .md\\:justify-start{
    justify-content: flex-start;
  }


  .md\\:justify-between{
    justify-content: space-between;
  }


  .md\\:space-x-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(5rem * var(--tw-space-x-reverse));
    margin-left: calc(5rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .md\\:space-x-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }


  .md\\:p-7{
    padding: 1.75rem;
  }


  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }


  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }


  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }


  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }


  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }


  .md\\:py-\\[80px\\]{
    padding-top: 80px;
    padding-bottom: 80px;
  }


  .md\\:pr-12{
    padding-right: 3rem;
  }


  .md\\:pr-5{
    padding-right: 1.25rem;
  }


  .md\\:text-center{
    text-align: center;
  }


  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }


  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }


  .md\\:text-\\[12px\\]{
    font-size: 12px;
  }


  .md\\:text-\\[16px\\]{
    font-size: 16px;
  }


  .md\\:text-\\[18px\\]{
    font-size: 18px;
  }


  .md\\:text-\\[20px\\]{
    font-size: 20px;
  }


  .md\\:text-\\[40px\\]{
    font-size: 40px;
  }


  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }


  .md\\:text-cust-16{
    font-size: 16px;
  }


  .md\\:text-cust-18{
    font-size: 18px;
  }


  .md\\:text-cust-22{
    font-size: 22px;
  }


  .md\\:text-cust-26{
    font-size: 26px;
  }


  .md\\:text-cust-42{
    font-size: 42px;
  }


  .md\\:text-cust-65{
    font-size: 65px;
  }


  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }


  .md\\:leading-10{
    line-height: 2.5rem;
  }
}
@media (min-width: 1024px){


  .lg\\:absolute{
    position: absolute;
  }


  .lg\\:relative{
    position: relative;
  }


  .lg\\:bottom-2{
    bottom: 0.5rem;
  }


  .lg\\:right-96{
    right: 24rem;
  }


  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }


  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }


  .lg\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }


  .lg\\:-mt-0{
    margin-top: -0px;
  }


  .lg\\:mb-10{
    margin-bottom: 2.5rem;
  }


  .lg\\:mb-7{
    margin-bottom: 1.75rem;
  }


  .lg\\:ml-40{
    margin-left: 10rem;
  }


  .lg\\:ml-48{
    margin-left: 12rem;
  }


  .lg\\:ml-60{
    margin-left: 15rem;
  }


  .lg\\:mr-10{
    margin-right: 2.5rem;
  }


  .lg\\:mr-40{
    margin-right: 10rem;
  }


  .lg\\:mr-48{
    margin-right: 12rem;
  }


  .lg\\:mr-5{
    margin-right: 1.25rem;
  }


  .lg\\:mr-60{
    margin-right: 15rem;
  }


  .lg\\:mt-0{
    margin-top: 0px;
  }


  .lg\\:mt-4{
    margin-top: 1rem;
  }


  .lg\\:block{
    display: block;
  }


  .lg\\:flex{
    display: flex;
  }


  .lg\\:hidden{
    display: none;
  }


  .lg\\:h-10{
    height: 2.5rem;
  }


  .lg\\:h-2\\/3{
    height: 66.666667%;
  }


  .lg\\:max-h-screen{
    max-height: 100vh;
  }


  .lg\\:min-h-screen{
    min-height: 100vh;
  }


  .lg\\:w-1\\/2{
    width: 50%;
  }


  .lg\\:w-1\\/3{
    width: 33.333333%;
  }


  .lg\\:w-1\\/5{
    width: 20%;
  }


  .lg\\:w-1\\/6{
    width: 16.666667%;
  }


  .lg\\:w-11\\/12{
    width: 91.666667%;
  }


  .lg\\:w-16{
    width: 4rem;
  }


  .lg\\:w-2\\/3{
    width: 66.666667%;
  }


  .lg\\:w-20{
    width: 5rem;
  }


  .lg\\:w-36{
    width: 9rem;
  }


  .lg\\:w-52{
    width: 13rem;
  }


  .lg\\:w-7\\/12{
    width: 58.333333%;
  }


  .lg\\:w-\\[1100px\\]{
    width: 1100px;
  }


  .lg\\:w-\\[20px\\]{
    width: 20px;
  }


  .lg\\:w-\\[30px\\]{
    width: 30px;
  }


  .lg\\:w-\\[35px\\]{
    width: 35px;
  }


  .lg\\:w-\\[370px\\]{
    width: 370px;
  }


  .lg\\:w-\\[40px\\]{
    width: 40px;
  }


  .lg\\:w-\\[50\\%\\]{
    width: 50%;
  }


  .lg\\:w-\\[60\\%\\]{
    width: 60%;
  }


  .lg\\:w-full{
    width: 100%;
  }


  .lg\\:min-w-\\[280px\\]{
    min-width: 280px;
  }


  .lg\\:min-w-\\[492px\\]{
    min-width: 492px;
  }


  .lg\\:min-w-\\[500px\\]{
    min-width: 500px;
  }


  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }


  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }


  .lg\\:flex-row{
    flex-direction: row;
  }


  .lg\\:items-start{
    align-items: flex-start;
  }


  .lg\\:justify-start{
    justify-content: flex-start;
  }


  .lg\\:justify-center{
    justify-content: center;
  }


  .lg\\:justify-between{
    justify-content: space-between;
  }


  .lg\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--tw-space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(3rem * var(--tw-space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--tw-space-x-reverse));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(4rem * var(--tw-space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-36 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(9rem * var(--tw-space-x-reverse));
    margin-left: calc(9rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-x-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--tw-space-x-reverse));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }


  .lg\\:space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }


  .lg\\:bg-transparent{
    background-color: transparent;
  }


  .lg\\:p-3{
    padding: 0.75rem;
  }


  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }


  .lg\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }


  .lg\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }


  .lg\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }


  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }


  .lg\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }


  .lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }


  .lg\\:py-\\[100px\\]{
    padding-top: 100px;
    padding-bottom: 100px;
  }


  .lg\\:pb-0{
    padding-bottom: 0px;
  }


  .lg\\:pl-24{
    padding-left: 6rem;
  }


  .lg\\:pr-10{
    padding-right: 2.5rem;
  }


  .lg\\:pr-16{
    padding-right: 4rem;
  }


  .lg\\:pr-20{
    padding-right: 5rem;
  }


  .lg\\:pt-14{
    padding-top: 3.5rem;
  }


  .lg\\:pt-20{
    padding-top: 5rem;
  }


  .lg\\:text-left{
    text-align: left;
  }


  .lg\\:text-start{
    text-align: start;
  }


  .lg\\:text-\\[30px\\]{
    font-size: 30px;
  }


  .lg\\:text-\\[40px\\]{
    font-size: 40px;
  }


  .lg\\:text-\\[45px\\]{
    font-size: 45px;
  }


  .lg\\:text-\\[50px\\]{
    font-size: 50px;
  }


  .lg\\:text-cust-16{
    font-size: 16px;
  }


  .lg\\:text-cust-18{
    font-size: 18px;
  }


  .lg\\:text-cust-21{
    font-size: 21px;
  }


  .lg\\:text-cust-22{
    font-size: 22px;
  }


  .lg\\:text-cust-26{
    font-size: 26px;
  }


  .lg\\:text-cust-42{
    font-size: 42px;
  }


  .lg\\:leading-tight{
    line-height: 1.25;
  }
}
@media (min-width: 1280px){


  .xl\\:h-11{
    height: 2.75rem;
  }


  .xl\\:h-7{
    height: 1.75rem;
  }


  .xl\\:h-8{
    height: 2rem;
  }


  .xl\\:w-16{
    width: 4rem;
  }


  .xl\\:w-20{
    width: 5rem;
  }


  .xl\\:w-40{
    width: 10rem;
  }


  .xl\\:w-\\[1400px\\]{
    width: 1400px;
  }


  .xl\\:w-\\[25px\\]{
    width: 25px;
  }


  .xl\\:w-\\[39px\\]{
    width: 39px;
  }


  .xl\\:w-\\[40px\\]{
    width: 40px;
  }


  .xl\\:w-\\[50px\\]{
    width: 50px;
  }


  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }


  .xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }


  .xl\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }


  .xl\\:text-\\[18px\\]{
    font-size: 18px;
  }
}
@media (min-width: 1400px){


  .w1400\\:w-20{
    width: 5rem;
  }


  .w1400\\:w-24{
    width: 6rem;
  }


  .w1400\\:w-48{
    width: 12rem;
  }
}
@media (min-width: 1536px){


  .\\32xl\\:ml-24{
    margin-left: 6rem;
  }


  .\\32xl\\:ml-60{
    margin-left: 15rem;
  }


  .\\32xl\\:ml-80{
    margin-left: 20rem;
  }


  .\\32xl\\:ml-96{
    margin-left: 24rem;
  }


  .\\32xl\\:mr-0{
    margin-right: 0px;
  }


  .\\32xl\\:mr-20{
    margin-right: 5rem;
  }


  .\\32xl\\:mr-24{
    margin-right: 6rem;
  }


  .\\32xl\\:mr-28{
    margin-right: 7rem;
  }


  .\\32xl\\:mr-32{
    margin-right: 8rem;
  }


  .\\32xl\\:mr-40{
    margin-right: 10rem;
  }


  .\\32xl\\:mr-44{
    margin-right: 11rem;
  }


  .\\32xl\\:mr-60{
    margin-right: 15rem;
  }


  .\\32xl\\:mr-80{
    margin-right: 20rem;
  }


  .\\32xl\\:mr-96{
    margin-right: 24rem;
  }


  .\\32xl\\:mt-5{
    margin-top: 1.25rem;
  }


  .\\32xl\\:h-8{
    height: 2rem;
  }


  .\\32xl\\:w-2\\/5{
    width: 40%;
  }


  .\\32xl\\:w-20{
    width: 5rem;
  }


  .\\32xl\\:w-56{
    width: 14rem;
  }


  .\\32xl\\:w-7\\/12{
    width: 58.333333%;
  }


  .\\32xl\\:w-8{
    width: 2rem;
  }


  .\\32xl\\:w-\\[30px\\]{
    width: 30px;
  }


  .\\32xl\\:space-x-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(6rem * var(--tw-space-x-reverse));
    margin-left: calc(6rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .\\32xl\\:space-x-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(8rem * var(--tw-space-x-reverse));
    margin-left: calc(8rem * calc(1 - var(--tw-space-x-reverse)));
  }


  .\\32xl\\:p-5{
    padding: 1.25rem;
  }


  .\\32xl\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }


  .\\32xl\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }


  .\\32xl\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }


  .\\32xl\\:px-\\[39\\.5px\\]{
    padding-left: 39.5px;
    padding-right: 39.5px;
  }


  .\\32xl\\:pl-36{
    padding-left: 9rem;
  }


  .\\32xl\\:pr-24{
    padding-right: 6rem;
  }


  .\\32xl\\:text-center{
    text-align: center;
  }


  .\\32xl\\:text-\\[15px\\]{
    font-size: 15px;
  }


  .\\32xl\\:text-\\[40px\\]{
    font-size: 40px;
  }


  .\\32xl\\:text-cust-16{
    font-size: 16px;
  }


  .\\32xl\\:text-cust-18{
    font-size: 18px;
  }


  .\\32xl\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (prefers-color-scheme: dark){


  .dark\\:bg-black\\/60{
    background-color: rgb(0 0 0 / 0.6);
  }


  .dark\\:focus\\:ring-purple-800:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(107 33 168 / var(--tw-ring-opacity));
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;;AAAd;;CAAc;;;AAAd;;;CAAc;;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;;AAAd;;EAAA,gBAAc;AAAA;;;AAAd;;;;;;;;CAAc;;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;;AAAd;;;CAAc;;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;;AAAd;;;;CAAc;;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,mBAAc;AAAA;;;AAAd;;;;;CAAc;;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,cAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;;AAAd;EAAA,eAAc;AAAA;;;AAAd;EAAA,WAAc;AAAA;;;AAAd;;;;CAAc;;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;;AAAd;;;;CAAc;;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,oBAAc;AAAA;;;AAAd;;;CAAc;;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,aAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,gBAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,wBAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,YAAc;AAAA;;;AAAd;;;CAAc;;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,wBAAc;AAAA;;;AAAd;;;CAAc;;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,kBAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;;AAAd;EAAA,UAAc;AAAA;;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,UAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,gBAAc;AAAA;;;AAAd;;;CAAc;;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,eAAc;AAAA;;;AAAd;;CAAc;;;AAAd;EAAA,eAAc;AAAA;;;AAAd;;;;CAAc;;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;;AAAd;;CAAc;;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;;AAAd,wEAAc;;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AAApB;;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB,UAAmB;EAAnB,SAAmB;EAAnB,iBAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAGnB;EACE,kCAAkC;EAClC,qBAAqB;;AAEvB;;AAEA;EACE,yDAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE;IACE,0BAA0B;EAC5B;EAGA;IACE,0BAA0B;EAC5B;AAJF;;AAOA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;;EAEX,gBAAgB;;AAElB;;;AAGA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,6FAA6F;;AAE/F,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB,EAAE,cAAc;EACvC,mDAAmD;AACrD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB,EAAE,cAAc;EACvC,mDAAmD;;AAErD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uCAAuC;EACzC;AACF;;;AAGA,UAAU;AACV;CACC,UAAU;CACV,WAAW;AACZ;;AAEA,UAAU;AACV;CACC,gBAAgB;AACjB;;AAEA,WAAW;AACX;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;AACZ;;AAEA,oBAAoB;AACpB;CACC,mBAAmB;AACpB;AAtLA;EAAA;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA,sBAsLC;EAtLD;AAsLC;AAtLD;EAAA,sBAsLC;EAtLD;AAsLC;AAtLD;EAAA,kBAsLC;EAtLD;AAsLC;AAtLD;EAAA,kBAsLC;EAtLD;AAsLC;AAtLD;EAAA,kBAsLC;EAtLD;AAsLC;AAtLD;EAAA,kBAsLC;EAtLD;AAsLC;AAtLD;EAAA;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA;AAsLC;AAtLD;EAAA,8BAsLC;EAtLD;AAsLC;AAtLD;EAAA,2GAsLC;EAtLD,yGAsLC;EAtLD;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA;AAsLC;AAtLD;EAAA,yBAsLC;EAtLD;AAsLC;AAtLD;EAAA,iBAsLC;EAtLD,iBAsLC;EAtLD;AAsLC;AAtLD;EAAA,oBAsLC;EAtLD;AAsLC;AAtLD;EAAA;AAsLC;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,iBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,uDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,2DAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,iBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,iBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,mBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,eAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,mBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,gBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,mDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,sDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,sDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,uDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,uDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,2DAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,+DAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,mBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,mBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,uBAsLC;IAtLD,oDAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,kBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA;EAsLC;;;EAtLD;IAAA,mBAsLC;IAtLD;EAsLC;AAAA;AAtLD;;;EAAA;IAAA;EAsLC;;;EAtLD;IAAA,oBAsLC;IAtLD;EAsLC;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n*{\n  font-family: \"Poppins\", sans-serif;\n  box-sizing:border-box;\n\n}\n\n.homelandingpage {\n  background-image: url('./assets/V2/background_landing.webp');\n  background-position: center;\n}\n\n.list-container {\n  position: absolute;\n  width: 90%;\n  height: 15%;\n  bottom: 20px;\n  right: 35px;\n  \n}\n\n@media (width: 344px) {\n  .titlesamsungfold {\n    font-size: 13px !important;\n  }\n}\n@media (width: 344px) {\n  .psamsungfold {\n    font-size: 12px !important;\n  }\n}\n\n.list-item {\n  border-radius: 25px;\n  overflow: hidden;\n  background-color: white;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  transform: translateY(100%);\n  opacity: 0;\n  animation: slideUpMotion 16s infinite;\n}\n\n@keyframes slideUpMotion {\n  0% {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  5%, 25% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  30% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n}\n\n/* Atur delay untuk setiap item */\n.list-item:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.list-item:nth-child(2) {\n  animation-delay: 4s;\n}\n\n.list-item:nth-child(3) {\n  animation-delay: 8s;\n}\n\n.list-item:nth-child(4) {\n  animation-delay: 12s;\n}\n\n\n/* Slider Container */\n.slider {\n  position: relative;\n  width: 100%;\n  \n  overflow: hidden;\n  \n}\n\n\n.bubble::before,\n.bubble::after {\n  content: \"\";\n  position: absolute;\n  width: 100px;\n  height: 100%;\n  z-index: 2;\n  background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)}\n\n/* Slide Track */\n.slide-track-image1 {\n  display: flex;\n  width: calc(210px * 22); /* 22 images */\n  animation: scroll-custom-image1 30s linear infinite;\n}\n\n/* bubble */\n.slide-track-image2 {\n  display: flex;\n  width: calc(280px * 10); /* 10 images */\n  animation: scroll-custom-image2 15s linear infinite;\n\n}\n\n/* Individual Slide */\n.slide-image1 {\n  display: flex;\n  width: 210px;\n  height: 75px;\n  align-items: center;\n  justify-content: center;\n}\n\n.slide-image2 {\n  width: 280px;\n}\n\n\n\n@keyframes scroll-custom-image1 {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(calc(-210px * 11));\n  }\n}\n\n@keyframes scroll-custom-image2 {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(calc(-280px * 5));\n  }\n}\n\n\n/* width */\n::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n\tbackground: #fff;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n\tbackground: #EC2027;\n\tborder-radius: 20px;\n\twidth: 50px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n\tbackground: #ff3a41;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
